// libs
import React from "react";

// constants
import { DEFAULT_ANALYTICS_CONTEXT_VALUE } from "@swiggy-private/analytics";

// types
import type { IAnalyticsContext } from "./types";

const AnalyticsContext = React.createContext<IAnalyticsContext>(DEFAULT_ANALYTICS_CONTEXT_VALUE);

export default AnalyticsContext;
